/* eslint-disable import/no-default-export */
import { HeaderTestIds } from '@trello/webdriverio-tests';
// eslint-disable-next-line no-restricted-imports
import { Noun, Verb } from 'common/debug/analytics-constants';
// eslint-disable-next-line no-restricted-imports
import { MemberAvatar } from 'components/member-avatar/member-avatar';
// eslint-disable-next-line no-restricted-imports
import { MemberMenuPopoverId } from 'components/popovers/popover-ids';
// eslint-disable-next-line no-restricted-imports
import analytics from 'debug/analytics';
// eslint-disable-next-line no-restricted-imports
import { showPopover, State } from 'modules';
import React, { lazy, Suspense } from 'react';
import { connect, Dispatch } from 'react-redux';
// eslint-disable-next-line no-restricted-imports
import { getMe, isPopoverShown } from 'selectors';
// eslint-disable-next-line no-restricted-imports
import { hasGold } from 'selectors/members';
// eslint-disable-next-line no-restricted-imports
import { MemberModel } from 'types';
import HeaderButton from './button';
import styles from './header.less';

const HeaderMemberMenuPromise = import(/* webpackChunkName: "gamma-member-menu-popover" */ 'components/popovers/header-member-menu');
const HeaderMemberMenu = lazy(() => HeaderMemberMenuPromise);

interface Props {
  hasMemberData: boolean;
  hasCrown: boolean;
  isActive: boolean;
  member: MemberModel | undefined;
  onClick: React.EventHandler<React.MouseEvent<HTMLButtonElement>>;
}

class HeaderMemberMenuButtonContainer extends React.Component<Props> {
  memberMenuButtonRef = React.createRef<HTMLButtonElement>();

  render() {
    const {
      hasCrown,
      hasMemberData,
      isActive,
      member,
      onClick,
    }: Props = this.props;
    const { name = '', username = '' } = member || {};
    const userTitle = `${name}${username && ` (${username})`}`;

    return (
      <>
        <HeaderButton
          className={styles.memberButton}
          onClick={onClick}
          ref={this.memberMenuButtonRef}
          testId={HeaderTestIds.MemberMenuButton}
          title={userTitle}
        >
          <MemberAvatar gold={hasCrown} member={member} size={32} />
        </HeaderButton>
        {hasMemberData &&
          isActive && (
            <Suspense fallback={null}>
              <HeaderMemberMenu
                target={() => this.memberMenuButtonRef.current}
              />
            </Suspense>
          )}
      </>
    );
  }
}

const mapStateToProps = (state: State, ownProps: object) => {
  return {
    hasMemberData: !!getMe(state),
    isActive: isPopoverShown(state, MemberMenuPopoverId),
    hasCrown: hasGold(state),
  };
};

const mapDispatchToProps = (dispatch: Dispatch<object>, ownProps: object) => {
  return {
    onClick(e: React.MouseEvent<HTMLElement>) {
      analytics.trackUE({
        category: Noun.HEADER,
        verb: Verb.OPENS,
        directObj: Noun.MEMBER_MENU,
        method: 'by using member menu button in header',
      });
      dispatch(showPopover({ name: MemberMenuPopoverId }));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(HeaderMemberMenuButtonContainer);



// WEBPACK FOOTER //
// ./app/gamma/src/components/header/member-menu-button.tsx